const texts = {
    "shipment-method-solution-title.PRINT_LABEL.default": {
        EN: "Service points",
        DA: "Udleveringssteder",
        DE: "Servicepunkte",
        NL: "Servicepunten",
        FR: "Points de service",
        IT: "Punti di servizio",
        ES: "Puntos de servicio",
        PT: "Pontos de serviço",
        FI: "Noutopisteet",
        SV: "Ombud",
    },
    "shipment-method-solution-title.PRINT_LABEL.DPD": {
        EN: "Find nearest service point <a target='_blank' href='https://pickup.dpd.co.uk/'>HERE</a>",
        DA: "Find nærmeste servicepunkt <a target='_blank' href='https://pickup.dpd.co.uk/'>HER</a>",
        DE: "Nächsten Servicepunkt finden <a target='_blank' href='https://pickup.dpd.co.uk/'>HIER</a>",
        NL: "Vind dichtstbijzijnde servicepunt <a target='_blank' href='https://pickup.dpd.co.uk/'>HIER</a>",
        FR: "Trouver le point de service le plus proche <a target='_blank' href='https://pickup.dpd.co.uk/'>ICI</a>",
        IT: "Trova il punto di servizio più vicino <a target='_blank' href='https://pickup.dpd.co.uk/'>QUI</a>",
        ES: "Encuentra el punto de servicio más cercano <a target='_blank' href='https://pickup.dpd.co.uk/'>AQUÍ</a>",
        PT: "Encontre o ponto de serviço mais próximo <a target='_blank' href='https://pickup.dpd.co.uk/'>AQUI</a>",
        FI: "Löydä lähin palvelupiste <a target='_blank' href='https://pickup.dpd.co.uk/'>TÄSTÄ</a>",
        SV: "Hitta närmaste ombud <a target='_blank' href='https://pickup.dpd.co.uk/'>HÄR</a>",
    },
    "shipment-method-solution-title.PACK_ITEMS_PRINT_LABEL": {
        EN: "Service points",
        DA: "Udleveringssteder",
        DE: "Servicepunkte",
        NL: "Servicepunten",
        FR: "Points de service",
        IT: "Punti di servizio",
        ES: "Puntos de servicio",
        PT: "Pontos de serviço",
        FI: "Noutopisteet",
        SV: "Ombud",
    },
    "shipment-method-solution-title.PRINT_LABEL_MANUAL_UPLOAD": {
        EN: "Service point",
        DA: "Servicepunkt",
        DE: "Servicepunkt",
        NL: "Servicepunt",
        FR: "Point de service",
        IT: "Punto di servizio",
        ES: "Punto de servicio",
        PT: "Ponto de serviço",
        FI: "Palvelupiste",
        SV: "Ombud",
    },
    "shipment-method-solution-title.PACK_ITEMS_LOCKER": {
        EN: "Locker",
        DA: "Pakkeboks",
        DE: "Schließfach",
        NL: "Locker",
        FR: "Casier",
        IT: "Armadietto",
        ES: "Taquilla",
        PT: "Armário",
        FI: "Pakettiautomaatti",
        SV: "Skåp",
        NO: "Pakkeboks",
    },
    "shipment-method-solution-title.LOCKER": {
        EN: "Locker",
        DA: "Pakkeboks",
        DE: "Schließfach",
        NL: "Locker",
        FR: "Casier",
        IT: "Armadietto",
        ES: "Taquilla",
        PT: "Armário",
        FI: "Pakettiautomaatti",
        SV: "Skåp",
        NO: "Pakkeboks",
    },
    "shipment-method-solution-title.PICKUP": {
        EN: "Home pickup",
        DA: "Hjemmeafhentning",
        DE: "Abholung zu Hause",
        NL: "Ophalen bij u thuis",
        FR: "Collecte à domicile",
        IT: "Ritiro a domicilio",
        ES: "Recogida a domicilio",
        PT: "Coleta em casa",
        FI: "Nouto kotoa",
        SV: "Hemupphämtning",
    },
    "shipment-method-solution-title.MANUAL": {
        EN: "Manual",
        DA: "Manuel",
        DE: "Manuell",
        NL: "Handmatig",
        FR: "Manuel",
        IT: "Manuale",
        ES: "Manual",
        PT: "Manual",
        FI: "Manuaalinen",
        SV: "Manuell",
    },
    "shipment-method-solution-title.RETURN_IN_STORE": {
        EN: "Return in store",
        DA: "Aflever i butik",
        DE: "Rückgabe im Geschäft",
        NL: "Retourneren in winkel",
        FR: "Retour en magasin",
        IT: "Reso in negozio",
        ES: "Devolución en tienda",
        PT: "Devolução na loja",
        FI: "Palauta myymälään",
        SV: "Returnera i butik",
    },
    "shipment-method-solution-subtitle.RETURN_IN_STORE": {
        EN: "",
        DA: "",
        DE: "",
        NL: "",
        FR: "",
        IT: "",
        ES: "",
        PT: "",
        FI: "",
    },
    "shipment-method-solution-title.RETURN_SLIP": {
        EN: "Return slip",
        DA: "Returseddel",
        DE: "Rücksendeschein",
        NL: "Retourbon",
        FR: "Bon de retour",
        IT: "Ricevuta di reso",
        ES: "Boleta de devolución",
        PT: "Comprovante de devolução",
        FI: "Palautuslomake",
        SV: "Returetikett",
    },
    "manual-shipping-option": {
        EN: "I book my own shipment",
        DA: "Jeg bestiller min egen forsendelse",
        DE: "Ich buche meinen eigenen Versand",
        NL: "Ik boek mijn eigen verzending",
        FR: "Je réserve mon propre envoi",
        IT: "Prenoto la mia spedizione",
        ES: "Reservo mi propio envío",
        PT: "Eu reservo meu próprio envio",
        FI: "Varaan oman toimituksen",
        SV: "Jag bokar min egen frakt",
    },
    "manual-upload-shipping-option": {
        EN: "Digital label",
        DA: "Digital etiket",
        DE: "Digitales Etikett",
        NL: "Digitaal label",
        FR: "Étiquette numérique",
        IT: "Etichetta digitale",
        ES: "Etiqueta digital",
        PT: "Etiqueta digital",
        FI: "Digitaalinen tarra",
        SV: "Digital etikett",
    },
    "return-slip-shipping-option": {
        EN: "Use return label included in package",
        DA: "Brug returetiket inkluderet i pakken",
        DE: "Verwenden Sie das im Paket enthaltene Rücksendeetikett",
        NL: "Gebruik het retourlabel in het pakket",
        FR: "Utilisez l'étiquette de retour incluse dans le colis",
        IT: "Usa l'etichetta di reso inclusa nel pacco",
        ES: "Use la etiqueta de devolución incluida en el paquete",
        PT: "Use a etiqueta de devolução incluída no pacote",
        FI: "Käytä pakettiin sisältyvää palautustarraa",
        SV: "Använd returetiketten som finns i paketet",
    },
};
export default texts;
